import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  d: "M18.4688 3H16.7812V5.53125H12.8438V3H11.1562V5.53125H7.21875V3H5.53125V5.53125H3V7.21875H5.53125V11.1562H3V12.8438H5.53125V16.7812H3V18.4688H5.53125V21H7.21875V18.4688H11.1562V21H12.8438V18.4688H16.7812V21H18.4688V18.4688H21V16.7812H18.4688V12.8438H21V11.1562H18.4688V7.21875H21V5.53125H18.4688V3ZM7.21875 7.21875H11.1562V11.1562H7.21875V7.21875ZM7.21875 16.7812V12.8438H11.1562V16.7812H7.21875ZM16.7812 16.7812H12.8438V12.8438H16.7812V16.7812ZM16.7812 11.1562H12.8438V7.21875H16.7812V11.1562Z",
  fill: "currentColor"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("path", _hoisted_1))
}